import React from 'react';
import { MessageProps } from '../ChatModal/types';
import './style.scss';

interface ImageProps {
    rawUrl: string;
    width: number;
    height: number;
}

const ImageMessage = ({ message }: MessageProps) => {
    const content = message.payload.richContent[0][0] as ImageProps;
    return (
        <div className="image-message">
            <img src={content.rawUrl} />
        </div>
    );
};

export default ImageMessage;
